import { Card, Col, FormLabel, Row } from "react-bootstrap";
import { teacherString } from "../../../utils/string";
import { KTSVG } from "../../../_uLearn/helpers";
import { CustomSelectWhite } from "../../custom/Select/CustomSelectWhite";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { PAGE_LIMIT } from "../../../utils/constants";
import { MASTER, SCHOOL, TEACHER } from "../../../api/apiEndPoints";
import APICallService from "../../../api/apiCallService";
import { teacherJSON } from "./../../../api/apiJSON/teacher";
import Pagination from "../../../Global/pagination";
import defaultImg from "../../../_uLearn/assets/media/svg_uLearn/default.svg";
import Loader from "../../../Global/loader";
import Method from "./../../../utils/methods";
import { useDebounce } from "../../../utils/useDebounce";
import { CustomComponentSelect } from "../../custom/Select/CustomComponentSelect";
import { listTeachers } from "../../../utils/storeString";
import { getKey, removeKey, setKey } from "../../../Global/history";
const Teachers = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [page, setPage] = useState<any>(getKey(listTeachers.page) || 1);
  const [pageLimit, setPageLimit] = useState<any>(
    getKey(listTeachers.limit) || PAGE_LIMIT
  );
  const [searchTerm, setSearchTerm] = useState<string>(
    getKey(listTeachers.search)?.toString() || ""
  );
  const [teacherData, setTeacherData] = useState<any>([]);
  const [classDetails, setClassDetails] = useState([]);
  const [selectedClass, setSelectedClass] = useState<any>(
    getKey(listTeachers.filterByClass) || ""
  );
  const [selectedClassOption, setSelectedClassOption] = useState([]);
  const [selectedSubjectList, setSelectedSubjectList] = useState([]);
  const [selectedSchool, setSelectedSchool] = useState<any>(
    getKey(listTeachers.filterBySchool) || ""
  );
  const [selectedSubject, setSelectedSubject] = useState<any>(
    getKey(listTeachers.filterBySubject) || []
  );
  const [schoolDetails, setSchoolDetails] = useState([]);
  useEffect(() => {
    (async () => {
      setLoading(true);
      await fetchTeacher(
        page,
        pageLimit,
        searchTerm,
        selectedClass,
        selectedSchool,
        selectedSubject
      );
      await fetchClassDetails();
      await fetchSchoolDetails();
      setLoading(false);
      setTimeout(() => {
        const pos = getKey(listTeachers.scrollPosition);
        window.scrollTo(0, pos);
      }, 500);
    })();
  }, []);
  const fetchTeacher = async (
    pageNo: number,
    limit: number,
    search?: string,
    className?: any,
    school?: string,
    subjects?: any
  ) => {
    setLoading(true);
    let params = {
      pageNo: pageNo,
      limit: limit,
      sortKey: "_createdAt",
      sortOrder: -1,
      searchTerm: search?.trim() || "",
      className: className && className.value.length > 0 ? className.value : "",
      school: school && school.length > 0 ? school : "",
      subjects: subjects && subjects.length ? subjects : [],
    };
    let apiService = new APICallService(
      TEACHER.GET_TEACHER_LIST,
      teacherJSON.listTeacher(params)
    );
    let response = await apiService.callAPI();
    if (response) {
      if (response.total) {
        setTotalRecords(response.total);
      } else {
        // let prevTotal = totalRecords;
        setTotalRecords(0);
      }
      setTeacherData(response.records);
    }
    setLoading(false);
  };
  const fetchClassDetails = async () => {
    setLoading(true);
    let apiService = new APICallService(MASTER.CLASS_SUBJECT_LIST);
    let response: any = await apiService.callAPI();
    if (response) {
      setClassDetails(response.records);
    }
    setLoading(false);
  };
  const fetchSchoolDetails = async () => {
    setLoading(true);
    let apiService = new APICallService(SCHOOL.GET_SCHOOL_LIST);
    let response: any = await apiService.callAPI();
    if (response) {
      setSchoolDetails(response.records);
      const schoolId = getKey(listTeachers.filterBySchool);
      const classId = getKey(listTeachers.filterByClass);
      if (schoolId) {
        const temp = response.records.find((item: any) => item._id == schoolId);
        setSelectedClassOption(temp.class);
        if (classId) {
          const tempSubject = temp.class.find(
            (item: any) => item.reference == classId.value
          );
          setSelectedSubjectList(tempSubject.subjects);
        }
      }
    }
    setLoading(false);
  };
  const handleCurrentPage = async (val: number) => {
    if (val === page || val.toString() === "...") return;
    setPage(val);
    setKey(listTeachers.page, val);
    await fetchTeacher(
      val,
      pageLimit,
      searchTerm,
      selectedClass,
      selectedSchool,
      selectedSubject
    );
  };
  const handleNextPage = async (val: number) => {
    setPage(val + 1);
    setKey(listTeachers.page, val + 1);
    await fetchTeacher(
      val + 1,
      pageLimit,
      searchTerm,
      selectedClass,
      selectedSchool,
      selectedSubject
    );
  };
  const handlePreviousPage = async (val: number) => {
    setPage(val - 1);
    setKey(listTeachers.page, val - 1);
    await fetchTeacher(
      val - 1,
      pageLimit,
      searchTerm,
      selectedClass,
      selectedSchool,
      selectedSubject
    );
  };
  const handlePageLimit = async (event: any) => {
    setPage(1);
    await setPageLimit(parseInt(event.target.value));
    setKey(listTeachers.page, 1);
    setKey(listTeachers.limit, parseInt(event.target.value));
    await fetchTeacher(
      1,
      event.target.value,
      searchTerm,
      selectedClass,
      selectedSchool,
      selectedSubject
    );
  };
  const handleClassChange = async (event: any) => {
    setKey(listTeachers.page, 1);
    setPage(1);
    if (event) {
      setSelectedSubject([]);
      setKey(listTeachers.filterByClass, event);
      await fetchTeacher(1, pageLimit, searchTerm, event, selectedSchool);
      setSelectedClass(event);
      setSelectedSubjectList(event.subjects);
      setPage(1);
    } else {
      await fetchTeacher(1, pageLimit, searchTerm, "", selectedSchool);
      setSelectedClass("");
      setSelectedSubjectList([]);
      removeKey(listTeachers.filterByClass);
      setSelectedSubject([]);
      setPage(1);
    }
    removeKey(listTeachers.filterBySubject);
  };
  const handleSchoolChange = async (event: any) => {
    setKey(listTeachers.page, 1);
    setPage(1);
    if (event) {
      setSelectedClass(null);
      setSelectedSubject([]);
      setKey(listTeachers.filterBySchool, event._id);
      await fetchTeacher(1, pageLimit, searchTerm, "", event._id);
      setSelectedSchool(event._id);
      setSelectedClassOption(event.class);
      setSelectedClass("");
      setPage(1);
    } else {
      setSelectedClass(null);
      setSelectedSubject([]);
      await fetchTeacher(1, pageLimit, searchTerm, "", "");
      setSelectedSchool("");
      setSelectedClassOption([]);
      removeKey(listTeachers.filterBySchool);
      setSelectedClass("");
      setPage(1);
    }
    removeKey(listTeachers.filterByClass);
    removeKey(listTeachers.filterBySubject);
  };

  const handleSubjectChange = async (event: any) => {
    setKey(listTeachers.filterBySubject, event);
    await fetchTeacher(
      1,
      pageLimit,
      searchTerm,
      selectedClass,
      selectedSchool,
      event
    );
    setSelectedSubject(event);
    setPage(1);
  };
  const debounce = useDebounce(fetchTeacher, 400);
  const handleSearchTerm = async (value: string) => {
    value = value.trimStart();
    //const regex = /^(\w+( \w+)*)( {0,1})$/;
    //const regex = /^(\w+( \w+)*)? ?$/;
    const regex = /^(\S+( \S+)*)? ?$/;
    const isValid = regex.test(value);
    if (!isValid) {
      return;
    }
    setSearchTerm(value);
    setKey(listTeachers.page, 1);
    if (value.trim().length > 2 && searchTerm !== value) {
      setPage(1);
      setLoading(true);
      setTotalRecords(0);
      await debounce(
        1,
        pageLimit,
        value,
        selectedClass,
        selectedSchool,
        selectedSubject
      );
      setLoading(false);
    } else if (value.trim().length <= 2 && value.length < searchTerm.length) {
      setPage(1);
      setLoading(true);
      setTotalRecords(0);
      await debounce(
        1,
        pageLimit,
        value,
        selectedClass,
        selectedSchool,
        selectedSubject
      );
      setLoading(false);
    }
    setKey(listTeachers.search, value);
  };
  const handleTeacherProfile = (teacherVal: string) => {
    setKey(listTeachers.scrollPosition, window.scrollY.toString());
    navigate("/teachers/view-teacher", { state: teacherVal });
  };
  return (
    <>
      <Row className="align-items-center">
        <Col xs className="align-self-center mb-5">
          <h1 className="fs-22 fw-bolder mb-0">{teacherString.titleTeacher}</h1>
        </Col>
        <Col xs={12}>
          <Card className="bg-light border mb-7">
            <Card.Body className="px-7">
              <Row className="align-items-center g-5">
                <Col md={4} lg={3}>
                  <FormLabel className="fs-16 fw-500 text-dark">
                    {teacherString.searchByKeyword}
                  </FormLabel>
                  <div className="d-flex align-items-center position-relative me-lg-4">
                    <KTSVG
                      path="/media/icons/duotune/general/gen021.svg"
                      className="svg-icon-3 position-absolute ms-3"
                    />
                    <input
                      type="text"
                      id="kt_filter_search"
                      className="form-control form-control-white min-h-60px form-control-lg ps-10"
                      placeholder="Search by teacher name…"
                      onChange={(e) => handleSearchTerm(e.target.value)}
                      value={searchTerm}
                      // onKeyUp={(e) => handleOnKeyUp(e)}
                    />
                  </div>
                </Col>
                <Col md={4} lg={3}>
                  <FormLabel className="fs-16 fw-500 text-dark">
                    {teacherString.filterBySchool}
                  </FormLabel>
                  <CustomSelectWhite
                    options={
                      schoolDetails.length
                        ? schoolDetails.map((val: any) => {
                            return {
                              value: val._id,
                              label: val.name,
                              _id: val._id,
                              class: val.class,
                            };
                          })
                        : []
                    }
                    onChange={(event: any) => {
                      handleSchoolChange(event);
                    }}
                    isClearable={true}
                    isMulti={false}
                    value={schoolDetails
                      .map((val: any) => {
                        return {
                          value: val._id,
                          label: val.name,
                          _id: val._id,
                          class: val.class,
                        };
                      })
                      .find((item: any) => item.value == selectedSchool)}
                  />
                </Col>
                {selectedSchool?.length ? (
                  <>
                    <Col md={4} lg={3}>
                      <FormLabel className="fs-16 fw-500 text-dark">
                        {teacherString.filterByClass}
                      </FormLabel>
                      <CustomSelectWhite
                        loading={loading}
                        options={
                          selectedClassOption.length
                            ? selectedClassOption.map((val: any) => {
                                return {
                                  value: val.reference,
                                  label: val.name,
                                  _id: val.reference,
                                  subjects: val.subjects,
                                };
                              })
                            : []
                        }
                        value={
                          selectedClass && selectedClass != null
                            ? {
                                value: selectedClass.reference,
                                label: selectedClass.label,
                                _id: selectedClass._reference,
                                subjects: selectedClass.subjects,
                              }
                            : null
                        }
                        onChange={(event: any) => {
                          handleClassChange(event);
                        }}
                        isMulti={false}
                        isClearable={true}
                      />
                    </Col>
                    <Col md={4} lg={3}>
                      <FormLabel className="fs-16 fw-500 text-dark">
                        {teacherString.filterBySubject}
                      </FormLabel>
                      <CustomComponentSelect
                        isLoading={loading}
                        options={
                          selectedSubjectList?.length
                            ? selectedSubjectList.map((val: any) => {
                                return {
                                  value: val._id,
                                  label: val.name,
                                  _id: val._id,
                                  id: val._id,
                                  name: val.name,
                                  title: val.name,
                                };
                              })
                            : []
                        }
                        onChange={(event: any) => {
                          handleSubjectChange(event);
                        }}
                        value={
                          selectedSubject?.length
                            ? selectedSubject.map((val: any) => {
                                return {
                                  value: val._id,
                                  label: val.label,
                                  _id: val._id,
                                  id: val._id,
                                  name: val.name,
                                  title: val.name,
                                };
                              })
                            : null
                        }
                        isMulti={true}
                        hideSelectedOptions={false}
                        // options={productStatusJSON}
                        // isClearable={Object.keys(productState).length}
                      />
                    </Col>
                  </>
                ) : (
                  <></>
                )}
              </Row>
            </Card.Body>
          </Card>
        </Col>
        <Col lg={12}>
          <Card className="border border-r10px">
            <Card.Body className="p-0">
              <div className="table-responsive">
                <table className="table table-rounded table-row-bordered align-middle gs-7 gy-4 mb-0">
                  <thead>
                    <tr className="fw-bold fs-16 fw-600 text-dark border-bottom h-70px align-middle gy-3">
                      <th className="min-w-225px ps-9">
                        {teacherString.teacherName}
                      </th>
                      <th className="min-w-145px">
                        {teacherString.phoneNumber}
                      </th>
                      <th className="min-w-175px text-center">
                        {teacherString.dateOfJoin}
                      </th>
                      {/* <th className="min-w-200px text-end"></th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <>
                        <td colSpan={6}>
                          <div className="w-100 d-flex justify-content-center">
                            <Loader loading={loading} />
                          </div>
                        </td>
                      </>
                    ) : (
                      <>
                        {teacherData.length ? (
                          <>
                            {teacherData.map(
                              (teacherVal: any, teacherIndex: number) => {
                                return (
                                  <tr>
                                    <td>
                                      <div className="d-flex align-items-center flex-row">
                                        <div className="symbol symbol-50px border">
                                          <img
                                            className="img-fluid border-r8px object-fit-contain"
                                            src={
                                              teacherVal?.image || defaultImg
                                            }
                                            alt=""
                                          />
                                        </div>
                                        <span
                                          className="fs-15 fw-600 ms-3"
                                          style={{ maxWidth: "200px" }}
                                        >
                                          {teacherVal.name}
                                          <br />
                                          <span className="text-muted fw-semibold text-muted d-block fs-7">
                                            {teacherVal.email}
                                          </span>
                                        </span>
                                      </div>
                                    </td>
                                    <td>
                                      <span className="fs-15 fw-600">
                                        {teacherVal?.phoneCountry +
                                          " " +
                                          teacherVal?.phone}
                                      </span>
                                    </td>
                                    <td>
                                      <div className="d-flex justify-content-center">
                                        <span className="fs-15 fw-600 text-dark">
                                          {Method.convertDateToDDMMYYYY(
                                            teacherVal?._createdAt
                                          ) || `29/11/2023`}
                                        </span>
                                      </div>
                                    </td>
                                    <td>
                                      <div className="my-1 ms-5 float-end"></div>
                                      <div className="float-end">
                                        <button
                                          className="btn btn-primary"
                                          onClick={() => {
                                            handleTeacherProfile(teacherVal);
                                          }}
                                          style={{ whiteSpace: "nowrap" }}
                                        >
                                          {teacherString.viewDetails}
                                        </button>
                                      </div>
                                    </td>
                                  </tr>
                                );
                              }
                            )}
                          </>
                        ) : (
                          <tr>
                            <td colSpan={4}>
                              <div className="w-100 fs-15 fw-bold d-flex justify-content-center">
                                {teacherString.noData}
                              </div>
                            </td>
                          </tr>
                        )}
                      </>
                    )}
                  </tbody>
                </table>
              </div>
            </Card.Body>
          </Card>
          {!loading && totalRecords > 0 ? (
            <Pagination
              totalRecords={totalRecords}
              currentPage={page}
              handleCurrentPage={handleCurrentPage}
              handleNextPage={handleNextPage}
              handlePreviousPage={handlePreviousPage}
              handlePageLimit={handlePageLimit}
              pageLimit={pageLimit}
            />
          ) : (
            <></>
          )}
        </Col>
      </Row>
    </>
  );
};
export default Teachers;
